export enum FundingFilterTypeEnum {
    TOTAL = 'Total',
    LAST_ROUND = 'Last Round'
}
